import { createSlice } from "@reduxjs/toolkit";
// eslint-disable-next-line import/no-extraneous-dependencies
import Cookies from "js-cookie";
import { isFulfilledAction, isPendingAction, isRejectedAction } from "../../utilities";
import { getFilteredPromoters } from "./actions";

const initialState = {
  loading: false,
  data: null,
  filteredPromoters: [],
  totalFiltered: 0,
};

export const promotersSlice = createSlice({
  name: "promoters",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getFilteredPromoters.fulfilled, (state, { payload }) => {
        Cookies.remove("applyFilter");

        return {
          ...state,
          filteredPromoters: payload?.content || [],
          totalFiltered: payload?.totalElements || 0,
        };
      })

      .addMatcher(isPendingAction("promoters"), (state) => ({
        ...state,
        loading: true,
      }))

      .addMatcher(isRejectedAction("promoters"), (state) => ({
        ...state,
        loading: false,
      }))

      .addMatcher(isFulfilledAction("promoters"), (state) => ({
        ...state,
        loading: false,
      }));
  },
});

export default promotersSlice.reducer;
